import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-33aa9316")

_pushScopeId("data-v-33aa9316")
const _hoisted_1 = { class: "your-data-form" }
const _hoisted_2 = { class: "heading-title" }
const _hoisted_3 = {
  class: "link",
  href: "https://storage.googleapis.com/maqqie/terms-and-conditions/terms-miseenplace.pdf",
  target: "__blank"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Confirmation = _resolveComponent("Confirmation")!
  const _component_FormRow = _resolveComponent("FormRow")!
  const _component_FormLabel = _resolveComponent("FormLabel")!
  const _component_TextInput = _resolveComponent("TextInput")!
  const _component_FormColumn = _resolveComponent("FormColumn")!
  const _component_CheckBox = _resolveComponent("CheckBox")!
  const _component_Button = _resolveComponent("Button")!
  const _component_FormGroup = _resolveComponent("FormGroup")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_FormGroup, { formGroup: _ctx.formGroup }, {
      default: _withId(() => [
        _createVNode(_component_Confirmation, {
          "is-open": _ctx.confirmationIsOpen,
          "onUpdate:is-open": _cache[1] || (_cache[1] = ($event: any) => (_ctx.confirmationIsOpen = $event)),
          "confirm-text": _ctx.$t('yourData.okay'),
          "modal-id": "confirmation",
          onClose: _ctx.clickHandlerForConfirm,
          onConfirm: _ctx.clickHandlerForConfirm
        }, {
          description: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('yourData.overlayMsgForCountryCode')), 1)
          ]),
          _: 1
        }, 8, ["is-open", "confirm-text", "onClose", "onConfirm"]),
        _createVNode(_component_FormRow, { class: "full-width" }, {
          default: _withId(() => [
            _createVNode("div", _hoisted_2, [
              _createVNode("span", null, _toDisplayString(_ctx.$t('yourData.header')), 1)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_FormRow, { class: "full-width" }, {
          default: _withId(() => [
            _createVNode(_component_FormLabel, null, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('yourData.name')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_TextInput, {
              "control-name": "name",
              placeholder: "",
              type: "text"
            })
          ]),
          _: 1
        }),
        _createVNode(_component_FormRow, { class: "full-width" }, {
          default: _withId(() => [
            _createVNode(_component_FormLabel, null, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('yourData.email')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_TextInput, {
              "control-name": "emailAddress",
              placeholder: "",
              type: "text"
            })
          ]),
          _: 1
        }),
        _createVNode(_component_FormColumn, { "left-column-size": 30 }, {
          left: _withId(() => [
            _createVNode(_component_FormLabel, null, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('yourData.countryCode')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_TextInput, {
              "control-name": "countryCode",
              placeholder: "",
              type: "text",
              disabled: "disabled",
              onClick: _ctx.openConfirmationBox
            }, null, 8, ["onClick"])
          ]),
          right: _withId(() => [
            _createVNode(_component_FormLabel, null, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('yourData.telephoneNumber')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_TextInput, {
              class: "appearance-none",
              "control-name": "telephoneNumber",
              placeholder: "",
              type: "tel",
              onKeyup: _cache[2] || (_cache[2] = ($event: any) => (_ctx.sanitizeInput()))
            })
          ]),
          _: 1
        }),
        _createVNode(_component_FormRow, { class: "full-width" }, {
          default: _withId(() => [
            _createVNode(_component_FormLabel, null, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('yourData.age')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_TextInput, {
              placeholder: _ctx.$t('yourData.ageMsg'),
              class: "appearance-none",
              "control-name": "age",
              type: "tel"
            }, null, 8, ["placeholder"])
          ]),
          _: 1
        }),
        _createVNode(_component_FormColumn, { "left-column-size": 30 }, {
          left: _withId(() => [
            _createVNode(_component_FormLabel, null, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('yourData.postCode')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_TextInput, {
              "control-name": "postCode",
              placeholder: "",
              type: "text"
            })
          ]),
          right: _withId(() => [
            _createVNode(_component_FormLabel, null, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('yourData.city')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_TextInput, {
              "control-name": "city",
              placeholder: "",
              type: "text"
            })
          ]),
          _: 1
        }),
        _createVNode(_component_FormRow, { class: "full-width" }, {
          default: _withId(() => [
            _createVNode(_component_CheckBox, {
              label: _ctx.$t('yourData.checkBoxLabel'),
              "control-name": "isChecked"
            }, {
              default: _withId(() => [
                _createVNode("div", null, [
                  _createTextVNode(_toDisplayString(_ctx.$t('yourData.agreement_text_part1')) + " ", 1),
                  _createVNode("a", _hoisted_3, _toDisplayString(_ctx.$t('yourData.agreement_text_part2')), 1),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('yourData.agreement_text_part3')), 1)
                ])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        }),
        _createVNode(_component_FormRow, { class: "full-width" }, {
          default: _withId(() => [
            _createVNode(_component_Button, {
              disabled: !_ctx.allComponentsFilled || _ctx.disableButton,
              showLoading: _ctx.showLoading,
              class: "full-width",
              size: "large",
              onClick: _ctx.saveYourData
            }, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('yourData.meeting')), 1)
              ]),
              _: 1
            }, 8, ["disabled", "showLoading", "onClick"])
          ]),
          _: 1
        }),
        _createVNode(_component_FormRow, { class: "full-width" }, {
          default: _withId(() => [
            _createVNode(_component_Button, {
              disabled: _ctx.disableButton,
              class: "full-width outlined",
              size: "large",
              onClick: _ctx.goToBackPage
            }, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('yourData.previousStep')), 1)
              ]),
              _: 1
            }, 8, ["disabled", "onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["formGroup"])
  ]))
})